import { AiButton } from "@/modules/ai/features/manipulate-text/ui/ai-button";
import { useModal } from "@/shared/modal";
import { createPortal } from "react-dom";
import { ReactNode } from "react";

export function ChatModal({
  children,
}: {
  children: ({ close }: { close: () => void }) => ReactNode;
}) {
  const { openModal, open, close } = useModal();

  return (
    <>
      <AiButton
        type={"default"}
        shape={"circle"}
        size={"middle"}
        onClick={open}
      />

      {openModal &&
        createPortal(
          <div className={"fixed right-5 bottom-5 z-50"}>
            {children({ close })}
          </div>,
          document.body,
        )}
    </>
  );
}
